module.exports = __webpack_public_path__ + "img/sohn-won-pyung.1a56b972.png";